/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_General_Show_Notification_BellInputs */

const en_forms_teams_settings_general_show_notification_bell = /** @type {(inputs: Forms_Teams_Settings_General_Show_Notification_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Bell`)
};

const de_forms_teams_settings_general_show_notification_bell = /** @type {(inputs: Forms_Teams_Settings_General_Show_Notification_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitteilungsglocke anzeigen`)
};

/**
* | output |
* | --- |
* | "Notification Bell" |
*
* @param {Forms_Teams_Settings_General_Show_Notification_BellInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_general_show_notification_bell = /** @type {((inputs?: Forms_Teams_Settings_General_Show_Notification_BellInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_General_Show_Notification_BellInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_general_show_notification_bell(inputs)
	return de_forms_teams_settings_general_show_notification_bell(inputs)
});